import { apiFetch } from '@/api'
import { Sorting } from '@/interfaces'

export const fetchAllSorting = async (): Promise<Sorting> => (await apiFetch('/sortings', { method: 'GET' })).data
